import React, { useContext } from 'react'
import { PageLink as Link } from 'src/app/AppAuth/PageLink'
import { RisksAbsoluteRoutes } from 'src/components/Reusable/RootPage/RootPage.constants'
import { useRisk } from 'src/pages/Risks/risks.hooks'
import { useInAudit } from 'src/context/AuditContext'
import AuthContext from 'src/context/authContext'
import { SubjectContainer } from './Subject.styles'

export const RiskContent = ({ riskId }: { riskId: string }): JSX.Element => {
  const risk = useRisk(riskId)
  const { auditId } = useInAudit()
  const { authCtx } = useContext(AuthContext)
  if (!risk) {
    return <></>
  }

  const url = auditId
    ? `/${authCtx.accountId}:${auditId}/${
        RisksAbsoluteRoutes.SHOW
      }/${encodeURIComponent(riskId)}`
    : `/${authCtx.accountId}/${RisksAbsoluteRoutes.SHOW}/${encodeURIComponent(
        riskId,
      )}`

  return (
    <SubjectContainer>
      <span>{`\u2022`}</span>
      <Link to={url}>{risk.getName()}</Link>
    </SubjectContainer>
  )
}
